/**
 * Datum als 'YYYY-MM-DD' in Lokalzeit.
 *
 * Nicht toISOString() nehmen: das rechnet in UTC und liefert zwischen 0 und
 * 2 Uhr (MESZ) bzw. für lokale Mitternacht den Vortag.
 */
export const localISODate = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
